<div class="footerNav innerContainer">
  <div *ngFor="let navigation of navigations" class="footerNav__block">
    <input
      class="footerNav__open__subMenu"
      type="radio"
      id="{{ navigation.title }}"
      hidden
      name="label"
      (click)="checkInput($event, 'radioCheckedSubMenu')"
    />
    <label for="{{ navigation.title }}" class="footerNav__title">
      {{ navigation.title }}
    </label>
    <div class="footerNav__list footerNav__subMenu">
      <vc-ref
        *ngFor="let content of navigation.content"
        class="footerNav__listItem"
        [resource]="content.link"
        [anchor]="isAnchored(content)"
      >
        {{ content.name }}
      </vc-ref>
    </div>
  </div>
</div>
